import { isUserLoggedIn, shouldShowGSTNWidget } from '@mmt/legacy-commons/Native/UserSession/UserSessionModule';
import { trackClick, trackClickEvent } from '@mmt/legacy-commons/Common/utils/OmnitureTrackerUtils';
import { showShortToast } from '@mmt/legacy-commons/Common/Components/Toast';
import { USER_CONSENT, USER_CONSENT_ERROR, GSTIN_OMNITURE } from './Helpers/constants';
import { pageName } from './Helpers/utils';
import { highlightUserConsentError } from './Store/GSTINactions';

export const gstinSubmit = async (gstinReducer: any, dispatchFun: Function) => {
    const { state, userConsent, lob } = gstinReducer;
    const showGSTINWidget = await shouldShowGSTNWidget();
    const isLoggedIn = await isUserLoggedIn() as boolean;

    const responseObject = {
        isUserLoggedIn: isLoggedIn,
        state: state,
        error: false,
        errorMsg: '',
    };

    if (!showGSTINWidget) {
        return responseObject;
    }

    const lobPageName = pageName(lob);
    trackClickEvent(lobPageName, GSTIN_OMNITURE.BAC_confirm_click);

    if (showGSTINWidget && !userConsent) {
        trackClick(lobPageName, GSTIN_OMNITURE.BAC_confirm_error, {});
        showShortToast(USER_CONSENT);
        updateHighlightUserConsentError(true, dispatchFun);
        return {
            ...responseObject,
            error: true,
            errorMsg: USER_CONSENT_ERROR,
        };
    }

    if (state !== '' && userConsent) {
        updateHighlightUserConsentError(false, dispatchFun);
        return responseObject;
    }

    return responseObject;
};

const updateHighlightUserConsentError = (value: boolean, dispatchFun: Function) => {
    try {
        dispatchFun(highlightUserConsentError(value));
    } catch (err) {
        // handle error
    }
};
